// Module
var code = "<div class=\"markdown-preview\"> <label><span data-translate>markdown.PREVIEW</span>:</label> <div data-ng-bind-html=\"vm.trustedHtml\"></div> </div>";
// Exports
var _module_exports =code;;
var path = 'common/vngageMarkdown/vngageMarkdownPreviewTemplate.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;